/* unplugin-vue-components disabled */import { render } from "./ButtonGroup.vue?vue&type=template&id=45280de8"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__